var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "organization-content" }, [
    _c(
      "div",
      { staticClass: "row1" },
      [
        _c("div", { staticClass: "attention-tips" }, [
          _c("i", { staticClass: "el-icon-s-opportunity" }),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("addEntityTips")) + "\n        "
          ),
        ]),
        _c("ImportEntity", {
          attrs: {
            siteId: _vm.getSite.siteId,
            visible: _vm.importEntityModalVisible,
          },
          on: {
            "on-upload-success": _vm.onBatchEntityUploadSuccess,
            onDialogClose: function ($event) {
              _vm.importEntityModalVisible = false
            },
          },
        }),
        _c(
          "el-button",
          {
            staticClass: "row1-btn wl-green",
            on: { click: _vm.onImportEntityClick },
          },
          [_vm._v(_vm._s(_vm.$t("IMPORT_ENTITY_BUTTON")))]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "tree-box" }, [
      _c(
        "div",
        { staticClass: "tree-box-inner" },
        [
          _c("el-tree", {
            ref: "tree",
            staticClass: "kccTree",
            attrs: {
              "default-expand-all": true,
              "expand-on-click-node": false,
              data: _vm.data,
              props: _vm.defaultProps,
              "node-key": "key",
            },
            on: { "node-click": _vm.handleNodeClick },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ node, data }) {
                  return _c(
                    "div",
                    { staticClass: "custom-tree-node" },
                    [
                      [
                        !data.isEdit
                          ? _c("span", { class: `level-${node.level}` }, [
                              !data.id
                                ? _c("span", { staticClass: "new-add" })
                                : _vm._e(),
                              data.isChanged
                                ? _c("span", { staticClass: "is-changed" })
                                : _vm._e(),
                              node.level === 1
                                ? _c("i", {
                                    staticClass: "el-icon-folder-opened",
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(node.label) +
                                  "\n                        "
                              ),
                            ])
                          : _c("el-input", {
                              ref: "input",
                              attrs: { size: "small" },
                              on: {
                                blur: function ($event) {
                                  return _vm.submitEdit(node, data)
                                },
                              },
                              model: {
                                value: _vm.currentEditEntityName,
                                callback: function ($$v) {
                                  _vm.currentEditEntityName = $$v
                                },
                                expression: "currentEditEntityName",
                              },
                            }),
                      ],
                      [
                        _c(
                          "span",
                          { staticClass: "opts" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: `${_vm.$t("btn_add")} ${
                                    node.level === 1
                                      ? _vm.$t("entity")
                                      : _vm.$t("subEntity")
                                  }`,
                                  placement: "top",
                                  "visible-arrow": false,
                                  "open-delay": 400,
                                },
                              },
                              [
                                [1, 2].includes(node.level)
                                  ? _c("i", {
                                      staticClass: "el-icon-plus",
                                      staticStyle: { color: "#1e49e2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAdd(node, data)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("COMMON_EDIT"),
                                  placement: "top",
                                  "visible-arrow": false,
                                  "open-delay": 400,
                                },
                              },
                              [
                                node.level > 1
                                  ? _c("i", {
                                      staticClass: "el-icon-edit",
                                      staticStyle: { color: "#1e49e2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(node, data)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("TREE_BTN_MOVE_UP"),
                                  placement: "top",
                                  "visible-arrow": false,
                                  "open-delay": 400,
                                },
                              },
                              [
                                node.level > 1
                                  ? _c("i", {
                                      staticClass: "el-icon-upload2",
                                      staticStyle: { color: "#1e49e2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.upNode(node, data)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("TREE_BTN_MOVE_DOWN"),
                                  placement: "top",
                                  "visible-arrow": false,
                                  "open-delay": 400,
                                },
                              },
                              [
                                node.level > 1
                                  ? _c("i", {
                                      staticClass: "el-icon-download",
                                      staticStyle: { color: "#1e49e2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downNode(node, data)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("COMMON_DELETE"),
                                  placement: "top",
                                  "visible-arrow": false,
                                  "open-delay": 400,
                                },
                              },
                              [
                                node.level > 1 &&
                                (node.level === 3 || !data.childEntity.length)
                                  ? _c("i", {
                                      staticClass: "el-icon-delete",
                                      staticStyle: { color: "#ed2124" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(node, data)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                    ],
                    2
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }